import { inject } from "aurelia-framework";

export class TranscriptGenerator {
  constructor() {
    this.awsJson = {};
    this.json1 = [];
    this.styles = [
      {
        Name: "Default",
        Fontname: "Arial",
        Fontsize: 36,
        PrimaryColour: "rgb(0 0 0 / 100)",
        PrimaryColourHex: "#000000",
        PrimaryColourASS: "&H00000000",
        PrimaryColourOpacity: 100,

        OutlineColour: "rgb(255 0 0 / 100)",
        OutlineColourHex: "#ff0000",
        OutlineColourASS: "&Hff0000ff",
        OutlineColourOpacity: 100,
        OutlineWidth: 0,

        SecondaryColour: "#00FFFF",

        BackColour: "rgb(255 255 255 / 0)",
        BackColourHex: "#ffffff",
        BackColourASS: "&Hffffffff",
        BackColourOpacity: 0,

        Bold: 1,
        Italic: 0,
        Underline: 0,
        StrikeOut: 0,
        ScaleX: 0,
        ScaleY: 0,
        Spacing: 0,
        Angle: 0,
        BorderStyle: 4,
        Outline: 3,
        Shadow: 5,
        Alignment: 1,
        MarginL: 0,
        MarginR: 0,
        MarginV: 0,
        Encoding: 0,
      },
      {
        Name: "Mr.Pink",
        Fontname: "Arial",
        Fontsize: 36,
        PrimaryColour: "rgb(255 255 255 / 100)",
        PrimaryColourHex: "#FCFFFF",
        PrimaryColourOpacity: 100,

        OutlineColour: "rba(0 0 0 / 100)",
        OutlineColourHex: "#000000",
        OutlineColourOpacity: 100,
        OutlineWidth: 0,

        SecondaryColour: "#00FFFF",

        BackColour: "rgb(255 00 217 / 100)",
        BackColourHex: "#ff00d9",
        BackColourOpacity: 100,

        Bold: 0,
        Italic: 0,
        Underline: 0,
        StrikeOut: 0,
        ScaleX: 0,
        ScaleY: 0,
        Spacing: 0,
        Angle: 0,
        BorderStyle: 4,
        Outline: 3,
        Shadow: 2,
        Alignment: 1,
        MarginL: 0,
        MarginR: 0,
        MarginV: 0,
        Encoding: 0,
      },
      {
        Name: "Slab",
        Fontname: "Arial",
        Fontsize: 36,
        PrimaryColour: "rgb(255 0 217 / 100)",
        PrimaryColourHex: "#FF00D9",
        PrimaryColourOpacity: 100,

        OutlineColour: "rgb(0 0 0 / 100)",
        OutlineColourHex: "#000000",
        OutlineColourOpacity: 0,
        OutlineWidth: 0,

        SecondaryColour: "#00FFFF",

        BackColour: "rgb(255 225 65 / 100)",
        BackColourHex: "#FFE141",
        BackColourOpacity: 100,

        Bold: 1,
        Italic: 0,
        Underline: 0,
        StrikeOut: 0,
        ScaleX: 0,
        ScaleY: 0,
        Spacing: 0,
        Angle: 0,
        BorderStyle: 4,
        Outline: 3,
        Shadow: 5,
        Alignment: 1,
        MarginL: 0,
        MarginR: 0,
        MarginV: 0,
        Encoding: 0,
      },
      {
        Name: "White box",
        Fontname: "Arial",
        Fontsize: 36,
        PrimaryColour: "rgb(0 0 0 / 100)",
        PrimaryColourHex: "#000000",
        PrimaryColourOpacity: 100,

        OutlineColour: "rgb(255 255 255 / 100)",
        OutlineColourHex: "#FFFFFF",
        OutlineColourOpacity: 0,
        OutlineWidth: 0,

        SecondaryColour: "#00FFFF",

        BackColour: "rgb(255 255 255 / 100)",
        BackColourHex: "#FFFFFF",
        BackColourOpacity: 100,

        Bold: 1,
        Italic: 0,
        Underline: 0,
        StrikeOut: 0,
        ScaleX: 0,
        ScaleY: 0,
        Spacing: 0,
        Angle: 0,
        BorderStyle: 4,
        Outline: 3,
        Shadow: 5,
        Alignment: 1,
        MarginL: 0,
        MarginR: 0,
        MarginV: 0,
        Encoding: 0,
      },
      {
        Name: "Underline Black box",
        Fontname: "Arial",
        Fontsize: 36,
        PrimaryColour: "rgb(255 255 255 / 100)",
        PrimaryColourHex: "#FFFFFF",
        PrimaryColourOpacity: 100,

        OutlineColour: "rgb(255 255 255 / 100)",
        OutlineColourHex: "#FFFFFF",
        OutlineColourOpacity: 0,
        OutlineWidth: 0,

        SecondaryColour: "#00FFFF",

        BackColour: "rgb(0 0 0 / 100)",
        BackColourHex: "#000000",
        BackColourOpacity: 100,

        Bold: 0,
        Italic: 0,
        Underline: 1,
        StrikeOut: 0,
        ScaleX: 0,
        ScaleY: 0,
        Spacing: 0,
        Angle: 0,
        BorderStyle: 4,
        Outline: 3,
        Shadow: 5,
        Alignment: 1,
        MarginL: 0,
        MarginR: 0,
        MarginV: 0,
        Encoding: 0,
      },
      {
        Name: "Italics ",
        Fontname: "Arial",
        Fontsize: 36,
        PrimaryColour: "rgb( 0 0 0 /100)",
        PrimaryColourHex: "#00000",
        PrimaryColourOpacity: 100,

        OutlineColour: "rgb( 0 0 0 /100)",
        OutlineColourHex: "#000000",
        OutlineColourOpacity: 0,
        OutlineWidth: 0,

        SecondaryColour: "#00FFFF",

        BackColour: "rbg(0 0 0 / 0)",
        BackColourHex: "#000000",
        BackColourOpacity: 0,

        Bold: 0,
        Italic: 1,
        Underline: 0,
        StrikeOut: 0,
        ScaleX: 0,
        ScaleY: 0,
        Spacing: 0,
        Angle: 0,
        BorderStyle: 4,
        Outline: 3,
        Shadow: 5,
        Alignment: 1,
        MarginL: 0,
        MarginR: 0,
        MarginV: 0,
        Encoding: 0,
      },
    ];

    this.selectedStyle = null;
    this.selectedIndex = null;
    this.selectedTabIndex = 1;
  }

  loadAWSJson(transcript_url, callback) {
    fetch(transcript_url)
      .then((res) => res.json())
      .then((out) => {
        console.log(out.transcript, this);
        this.awsJson = out.transcript;

        if (out.transcript.styles) {
          this.json1 = out.transcript.caption;
          this.selectedStyle=out.transcript.styles
          callback(out.transcript);
        } else {
          this.generateTranscrptJsonFromAWS();
          callback(this.json1);
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  }
  generateTranscrptJsonFromAWS() {
    this.json1 = [];
    var start_time = "";
    var end_time = "";
    var sentence = "";
    var n = 1;
    var t = 1;
    var wtb = 5;

    var items = this.awsJson.results.items;
    for (let i = 0; i < items.length; i++) {
      if (items[i].type == "pronunciation") {
        if (start_time == "") start_time = items[i].start_time;
        end_time = items[i].end_time;
        sentence += items[i].alternatives[0].content + " ";
        t++;

        console.log(items[i].alternatives[0].content, "=>", sentence);
      } else if (
        items[i].type == "punctuation" &&
        items[i].alternatives[0].content == "."
      ) {
        if (sentence.trim())
          this.json1.push({
            start_time: this.formatSecondsToHMSWithMilliseconds(start_time),
            end_time: this.formatSecondsToHMSWithMilliseconds(end_time),
            sentence: sentence.trim(),
          });

        sentence = "";
        start_time = "";
        n++;
        t = 1;
      } else if (
        items[i].type == "punctuation" &&
        items[i].alternatives[0].content != "." &&
        items[i].alternatives[0].content != ""
      ) {
        if (items[i].alternatives[0].content == ",")
          sentence = sentence.trim() + items[i].alternatives[0].content + " ";
        else {
          sentence = sentence.trim() + items[i].alternatives[0].content;
        }
      }
      if (t > wtb) {
        this.json1.push({
          start_time: this.formatSecondsToHMSWithMilliseconds(start_time),
          end_time: this.formatSecondsToHMSWithMilliseconds(end_time),
          sentence: sentence.trim(),
        });

        sentence = "";
        start_time = "";
        n++;
        t = 1;
      } else if (i == items.length - 1 && sentence.trim()) {
        this.json1.push({
          start_time: this.formatSecondsToHMSWithMilliseconds(start_time),
          end_time: this.formatSecondsToHMSWithMilliseconds(end_time),
          sentence: sentence.trim(),
        });
      }
    }

    console.log(this.json1);
  }

  onChangeTab(index) {
    this.selectedTabIndex = index;
  }

  onSelectedStyle(index) {
    console.log(index);
    if (index >= 0) {
      this.selectedStyle = Object.assign({}, this.styles[index]);
      this.selectedIndex = index;
      this.selectedStyle.PrimaryColourASS = this.convertRGBAToASS(
        this.selectedStyle.PrimaryColour
      );
      this.selectedStyle.BackColourASS = this.convertRGBAToASS(
        this.selectedStyle.BackColour
      );

      this.selectedStyle.OutlineColourASS = this.convertRGBAToASS(
        this.selectedStyle.OutlineColour
      );
    }
    console.log(this.selectedStyle);
  }
  onResetDesign() {
    this.selectedStyle = Object.assign({}, this.styles[this.selectedIndex]);
  }

  onBack() {
    this.selectedStyle = null;
    this.selectedIndex = null;
  }

  onChangeColors(e) {
    if (this.selectedStyle) {
      const { name, value } = e.target;

      this.selectedStyle[name] = value;

      if (name == "BackColour") {
        this.selectedStyle[name] = this.hexToRGB(
          value,
          this.selectedStyle.BackColourOpacity
        );
        this.selectedStyle.BackColourHex = value;

        this.selectedStyle.BackColourASS = this.convertRGBAToASS(
          this.selectedStyle.BackColour
        );
      } else if (name == "BackColourOpacity") {
        this.selectedStyle[name] = value;
        this.selectedStyle.BackColour = this.editRGBToWithOpacity(
          this.selectedStyle.BackColour,
          this.selectedStyle.BackColourOpacity
        );
        this.selectedStyle.BackColourASS = this.convertRGBAToASS(
          this.selectedStyle.BackColour
        );
      } else if (name == "PrimaryColour") {
        this.selectedStyle[name] = this.hexToRGB(
          value,
          this.selectedStyle.PrimaryColourOpacity
        );
        this.selectedStyle.PrimaryColourHex = value;
        this.selectedStyle.PrimaryColourASS = this.convertRGBAToASS(
          this.selectedStyle.PrimaryColour
        );
      } else if (name == "PrimaryColourOpacity") {
        this.selectedStyle[name] = value;
        this.selectedStyle.PrimaryColour = this.editRGBToWithOpacity(
          this.selectedStyle.PrimaryColour,
          this.selectedStyle.PrimaryColourOpacity
        );
        this.selectedStyle.PrimaryColourASS = this.convertRGBAToASS(
          this.selectedStyle.PrimaryColour
        );
      } else if (name == "OutlineColour") {
        this.selectedStyle[name] = this.hexToRGB(
          value,
          this.selectedStyle.OutlineColourOpacity
        );
        this.selectedStyle.OutlineColorHex = value;
        this.selectedStyle.OutlineColourASS = this.convertRGBAToASS(
          this.selectedStyle.OutlineColour
        );
      } else if (name == "OutlineColourOpacity") {
        this.selectedStyle[name] = value;
        this.selectedStyle.OutlineColour = this.editRGBToWithOpacity(
          this.selectedStyle.OutlineColour,
          this.selectedStyle.OutlineColourOpacity
        );
        this.selectedStyle.OutlineColourASS = this.convertRGBAToASS(
          this.selectedStyle.OutlineColour
        );
      }

      console.log(
        this.selectedStyle.PrimaryColour,
        this.selectedStyle.BackColour,
        this.selectedStyle.OutlineColour
      );
    }
  }
  onChangeStyle(name, value) {
    this.selectedStyle[name] = value;

    // console.log(this.selectedStyle, name, value);
  }

  // helpers

  formatSecondsToHMSWithMilliseconds(seconds) {
    var pad = (num, size) => ("000" + num).slice(size * -1);
    var minutes = Math.floor((seconds % 3600) / 60);
    var secs = Math.floor(seconds % 60);
    var milliseconds = Math.floor((seconds - Math.floor(seconds)) * 1000);
    return `${pad(minutes, 2)}:${pad(secs, 2)}.${Math.floor(
      (pad(milliseconds, 3) % 1000) / 10
    )}`;
    x``;
  }
  convertRGBAToASS(rgbString) {
    // Extract RGB values and alpha percentage from the CSS string
    console.log(rgbString);
    if (rgbString) {
      const [r, g, b, alpha] = rgbString.match(/\d+/g);

      console.log(r, g, b, alpha, rgbString.match(/\d+/g));
      // Convert decimal RGB values to hexadecimal
      const hexR = Number(r).toString(16).padStart(2, "0");
      const hexG = Number(g).toString(16).padStart(2, "0");
      const hexB = Number(b).toString(16).padStart(2, "0");

      // Convert alpha percentage to hexadecimal (normalized to range 0-255)
      const alphaHex = Math.round((Number(Math.abs(100 - alpha)) / 100) * 255)
        .toString(16)
        .padStart(2, "0");

      // Construct the ASS/SSA color format string
      const assColor = `&H${alphaHex.toUpperCase()}${hexB.toUpperCase()}${hexG.toUpperCase()}${hexR.toUpperCase()}`;

      return assColor;
    }
    return null;
  }
  editRGBToWithOpacity(rgbString, opacity) {
    // Extract RGB values and alpha percentage from the CSS string
    const [r, g, b] = rgbString.match(/\d+/g);
    return `rgb(${r.toUpperCase()} ${g.toUpperCase()} ${b.toUpperCase()} / ${opacity}%)`;
  }
  opacityToHex(opacityPercentage) {
    const decimalOpacity = Math.round((opacityPercentage / 100) * 255);
    const hexOpacity = decimalOpacity
      .toString(16)
      .toUpperCase()
      .padStart(2, "0");
    return hexOpacity;
  }
  hexToRGB(hexColor, opacityPercentage) {
    // Remove '#' if present and extract RGB components
    hexColor = hexColor.replace("#", "");
    const red = parseInt(hexColor.substring(0, 2), 16);
    const green = parseInt(hexColor.substring(2, 4), 16);
    const blue = parseInt(hexColor.substring(4, 6), 16);

    // Ensure the input opacity is within the valid range (0 to 100)
    if (opacityPercentage < 0 || opacityPercentage > 100) {
      return "Invalid input: opacity should be between 0 and 100.";
    }

    // Construct the RGBA string
    const rgbaString = `rgb(${red} ${green} ${blue} / ${opacityPercentage}%)`;
    return rgbaString;
  }
  colorToHex(red, green, blue) {
    // Ensure the input values are within the valid range (0-255)
    if (
      red < 0 ||
      red > 255 ||
      green < 0 ||
      green > 255 ||
      blue < 0 ||
      blue > 255
    ) {
      return "Invalid input: RGB values should be between 0 and 255.";
    }

    // Convert each RGB component to its two-digit hexadecimal representation
    const redHex = red.toString(16).padStart(2, "0").toUpperCase();
    const greenHex = green.toString(16).padStart(2, "0").toUpperCase();
    const blueHex = blue.toString(16).padStart(2, "0").toUpperCase();

    // Construct the hexadecimal color string
    const hexColor = `#${redHex}${greenHex}${blueHex}`;
    return hexColor;
  }
  convertRGBToHex(rgbString) {
    // Extract RGB values and alpha percentage from the CSS string
    if (rgbString) {
      const [r, g, b, alpha] = rgbString.match(/\d+/g);

      // Convert decimal RGB values to hexadecimal
      const hexR = Number(r).toString(16).padStart(2, "0");
      const hexG = Number(g).toString(16).padStart(2, "0");
      const hexB = Number(b).toString(16).padStart(2, "0");

      // Construct the ASS/SSA color format string
      const assColor = `#${hexR.toUpperCase()}${hexG.toUpperCase()}${hexB.toUpperCase()}`;

      return assColor;
    }
    return null;
  }
}
